// extracted by mini-css-extract-plugin
export default {"session-expired":"session-expired_session-expired__3GRof","container":"session-expired_container__7clGW","title":"session-expired_title__N-Ajd","body":"session-expired_body__glH2i"};